import React from 'react';
import song1 from '../../lyrics/the-valley-is-great.js';
import song2 from '../../lyrics/blessing-in-disguise.js';
import song3 from '../../lyrics/we-are-gonna-die.js';
import song4 from '../../lyrics/part-ways.js';
import song5 from '../../lyrics/only-god-knows.js';
import song6 from '../../lyrics/only-god-knows-reprise.js';

import IconRewind from '../../assets/icons/icon-rewind.svg';

import './home.css';

import StayCalm1 from '../../assets/fun-fact/stay-calm-1.png';
// import StayCalm2 from '../../assets/fun-fact/stay-calm-2.png';
// import StayCalm3 from '../../assets/fun-fact/stay-calm-3.png';

const TAB_ONE = 'tab_one';
const TAB_TWO = 'tab_two';
const TAB_THREE = 'tab_three';
const TAB_FOUR = 'tab_four';
const TAB_FIVE = 'tab_five';
const TAB_SIX = 'tab_six';
const PREVIEW = 'preview';

const AUDIO_ONE = 'https://firebasestorage.googleapis.com/v0/b/test-385af.appspot.com/o/THE%20VALLEY%20MUSICAL%20AUDIO%20FILES%2FThe%20Valley%20Is%20Great.wav?alt=media&token=c59c0132-6982-45a2-9583-7ffb40312989';
const AUDIO_TWO = 'https://firebasestorage.googleapis.com/v0/b/test-385af.appspot.com/o/THE%20VALLEY%20MUSICAL%20AUDIO%20FILES%2FBlessing%20In%20Disguise.wav?alt=media&token=43150759-5f3c-4c7b-82e8-341fb3d381d9';
const AUDIO_THREE = 'https://firebasestorage.googleapis.com/v0/b/test-385af.appspot.com/o/THE%20VALLEY%20MUSICAL%20AUDIO%20FILES%2FWe%20Are%20Gonna%20Die.wav?alt=media&token=53d0064b-d158-4bcd-95a4-c7b9663dd236';
const AUDIO_FOUR = 'https://firebasestorage.googleapis.com/v0/b/test-385af.appspot.com/o/THE%20VALLEY%20MUSICAL%20AUDIO%20FILES%2FPart%20Ways.wav?alt=media&token=d09b40c0-98a1-4293-97a1-bcc7a12544f6';
const AUDIO_FIVE = 'https://firebasestorage.googleapis.com/v0/b/test-385af.appspot.com/o/THE%20VALLEY%20MUSICAL%20AUDIO%20FILES%2FOnly%20God%20Knows.wav?alt=media&token=8493a523-7854-485b-be75-84c064a4262a';
const AUDIO_SIX = 'https://firebasestorage.googleapis.com/v0/b/test-385af.appspot.com/o/THE%20VALLEY%20MUSICAL%20AUDIO%20FILES%2FOnly%20God%20Knows%20-%20Reprise.wav?alt=media&token=34dbfff0-4cea-4b34-b672-ad4e07253cd3';
const AUDIO_PREVIEW = 'https://firebasestorage.googleapis.com/v0/b/test-385af.appspot.com/o/THE%20VALLEY%20MUSICAL%20AUDIO%20FILES%2FThe%20Valley%20-%20Preview.wav?alt=media&token=9fb91785-3ada-48ef-bf2f-fb827c170090';

const tabs = [TAB_ONE, TAB_TWO, TAB_THREE, TAB_FOUR, TAB_FIVE, TAB_SIX]

const Home = () => {
	const [openTab, setOpenTab] = React.useState(null);

	const [lyricsStartup, setLyricsStartup] = React.useState("-");
	const [lyricsVCs, setLyricsVCs] = React.useState("-");
	const [lyricsGreg, setLyricsGreg] = React.useState("-");

	const [playing, setPlaying] = React.useState(null);
	const [audio, setAudio] = React.useState(null);
	const [time, setTime] = React.useState(0);

	React.useEffect(() => {

	}, [])

	React.useEffect(() => {
		if (!audio) return;
		setLyricsStartup("-")
		setLyricsVCs("-")
		setLyricsGreg("-")

		// Deciding which lyrics to get
		// (this could have been done when assiging a song,
		// but it's fine)
		let lyrics = []
		switch(openTab) {
			case TAB_ONE:
				lyrics = song1.lyrics
				break;
			case TAB_TWO:
				lyrics = song2.lyrics
				break;
			case TAB_THREE:
				lyrics = song3.lyrics
				break;
			case TAB_FOUR:
				lyrics = song4.lyrics
				break;
			case TAB_FIVE:
				lyrics = song5.lyrics
				break;
			case TAB_SIX:
				lyrics = song6.lyrics
				break;
		}

		audio.ontimeupdate = () => {
			const time = audio.currentTime;
			setTime(time)

			const index = syncLyrics(lyrics, time);

        	if (index == null) return;

			// Show who's singing
			const characters = lyrics[index].characters
			
			for (let i = 0; i < characters.length; i++) {
				if (characters[i] === "startup") {
					setLyricsStartup(lyrics[index].lyric)
				} else if (characters[i] === "vc") {
					setLyricsVCs(lyrics[index].lyric)
				} else if (characters[i] === "greg") {
					setLyricsGreg(lyrics[index].lyric)
				}
			}
		}

		audio.onended = () => {
			handleOpenTab(openTab)
		};
	}, [audio])

	React.useEffect(() => {
		if (!audio) return;

		if (playing) {
			console.log("playing audio")
			audio.play();
		}else {
			console.log("pausing audio")
			audio.pause();
		}
	}, [playing])

	// "03:24.73" => 204.73 (total time in seconds)
	const parseTime = time => {
		const minsec = time.split(":");

		const min = parseInt(minsec[0]) * 60;
		const sec = parseFloat(minsec[1]);

		return min + sec;
	}

	const syncLyrics = (lyrics, time) => {
		const scores = [];
	
		lyrics.forEach(lyric => {
			// Get the gap or distance or we call it score
			const score = time - parseTime(lyric.time);
	
			// Only accept score with positive values
			if (score >= 0) scores.push(score);
		});
	
		if (scores.length == 0) return null;
	
		// Get the smallest value from scores
		const closest = Math.min(...scores);
	
		// Return the index of closest lyric
		return scores.indexOf(closest);
	}

	const handleOpenTab = tab => {
		// Close
		if (openTab === tab) {
			setOpenTab(null);
			audio.pause();
			setAudio(null);
			setPlaying(null);
			return;
		}

		// Resetting lyrics
		setTimeout(() => {
			setLyricsStartup('-');
			setLyricsGreg('-');
			setLyricsVCs('-');
		}, 1000);

		// For example: tab 1 was open and playing and user opened tab 2
		setOpenTab(null);
		if (audio) audio.pause();
		setAudio(null);
		setPlaying(null);

		// Open
		setOpenTab(tab);
		assignSongToPlay(tab);
	}

	const handlePlayPause = () => setPlaying(!playing)

	const rewind = () => {
		setLyricsStartup('-');
		setLyricsGreg('-');
		setLyricsVCs('-');
		audio.currentTime = time - 15
	}

	const fastfwd = () => {
		setLyricsStartup('-');
		setLyricsGreg('-');
		setLyricsVCs('-');
		audio.currentTime = time + 15
	}

	const assignSongToPlay = tab => {
		console.log(tab)
		switch(tab) {
			case PREVIEW:
				if (!playing) {
					setAudio(new Audio(AUDIO_PREVIEW));
				}
				setOpenTab(null);
				handlePlayPause();
				break;
			case TAB_ONE:
				setAudio(new Audio(AUDIO_ONE));
				break;
			case TAB_TWO:
				setAudio(new Audio(AUDIO_TWO));
				break;
			case TAB_THREE:
				setAudio(new Audio(AUDIO_THREE));
				break;
			case TAB_FOUR:
				setAudio(new Audio(AUDIO_FOUR));
				break;
			case TAB_FIVE:
				setAudio(new Audio(AUDIO_FIVE));
				break;
			case TAB_SIX:
				setAudio(new Audio(AUDIO_SIX));
				break;
		}
	}

	const secToMin = s => {
		// e.g. 68.33
		const min = Math.floor(time / 60);
		let sec = Math.floor(s - (min * 60));

		if (sec.toString().length === 1) sec = `0${sec}`

		return `${min}:${sec}`
	}

	const renderLyrics = () => {
		let borderStylesStartup = {}
		if (lyricsStartup !== '-') {
			borderStylesStartup = { border: "3px solid #f55656" }
		}

		let borderStylesGreg = {}
		if (lyricsGreg !== '-') {
			borderStylesGreg = { border: "3px solid #71b3f5" }
		}

		let borderStylesVCs = {}
		if (lyricsVCs !== '-') {
			borderStylesVCs = { border: "3px solid #6ade7c" }
		}

		return (
			<div className="character-lyrics">
				<div className="lyrics" style={borderStylesStartup}>
					<p className="char">STARTUPS</p>
					<p className="text">{lyricsStartup}</p>
				</div>
				<div className="lyrics" style={borderStylesGreg}>
					<p className="char">GREG</p>
					<p className="text">{lyricsGreg}</p>
				</div>
				<div className="lyrics" style={borderStylesVCs}>
					<p className="char">VCs</p>
					<p className="text">{lyricsVCs}</p>
				</div>
			</div>
		)
	}

	const renderCommands = () => {
		return (
			<>
				{playing && (
					<>
						<button className="btn" onClick={() => rewind()}>
							<img src={IconRewind} />
							15 secs
						</button>
						<button className="btn" onClick={() => fastfwd()}>
							15 secs
							<img src={IconRewind} style={{ transform: 'rotateY(180deg)' }}/>
						</button>
					</>
				)}
				<button className="btn" onClick={() => handlePlayPause()}>{playing ? "Pause" : "Play"}</button>
			</>
		)
	}

	return (
        <div className="home-container m-auto">
			<div className="sneak-peek">
				<p className="txt">Here's a sneak peek of our show <span style={{ opacity: 0.5 }}>(40 seconds)</span>:</p>
				<button className="btn" onClick={() => assignSongToPlay(PREVIEW)}>{playing && !tabs.includes(openTab) ? "Pause" : "Play"}</button>
			</div>
			<h3 className="title"><span className="add-bb">The Valley</span> starts here:</h3>
			<div className="item">
				<div className="item-header">
					<p className="song-title">1. The Valley Is Great</p>
					<div className="buttons">
						<p className="time">{openTab === TAB_ONE && playing ? `${secToMin(time)} - ` : null}4:28</p>
						{openTab === TAB_ONE && renderCommands()}
						<button className="btn" onClick={() => handleOpenTab(TAB_ONE)}>{openTab === TAB_ONE ? "Close" : "Open"}</button>
					</div>
				</div>
				{openTab === TAB_ONE && renderLyrics()}
			</div>
			<div className="item">
				<div className="item-header">
					<p className="song-title">2. Blessing In Disguise</p>
					<div className="buttons">
						<p className="time">{openTab === TAB_TWO && playing ? `${secToMin(time)} - ` : null}3:06</p>
						{openTab === TAB_TWO && renderCommands()}
						<button className="btn" onClick={() => handleOpenTab(TAB_TWO)}>{openTab === TAB_TWO ? "Close" : "Open"}</button>
					</div>
				</div>
				{openTab === TAB_TWO && (
					<>
						{renderLyrics()}
						<div className="fun-fact" style={{ marginBottom: 10 }}>
							<div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
								<span className="circle" />
								<p className="t">FUN FACT</p>
							</div>
							<p>The chorus of this song was based on SVB's actual CEO recommending clients to "Stay Calm":</p>
							<a className="fun-fact-link" target="_blank" href="https://www.latimes.com/business/story/2023-03-09/silicon-valley-bank-startups-panic"><img src={StayCalm1} /></a>
						</div>
					</>
				)}
			</div>
			<div className="item">
				<div className="item-header">
					<p className="song-title">3. We Are Gonna Die</p>
					<div className="buttons">
						<p className="time">{openTab === TAB_THREE && playing ? `${secToMin(time)} - ` : null}4:10</p>
						{openTab === TAB_THREE && renderCommands()}
						<button className="btn" onClick={() => handleOpenTab(TAB_THREE)}>{openTab === TAB_THREE ? "Close" : "Open"}</button>
					</div>
				</div>
				{openTab === TAB_THREE && renderLyrics()}
			</div>
			<div className="item">
				<div className="item-header">
					<p className="song-title">4. Part Ways</p>
					<div className="buttons">
						<p className="time">{openTab === TAB_FOUR && playing ? `${secToMin(time)} - ` : null}2:41</p>
						{openTab === TAB_FOUR && renderCommands()}
						<button className="btn" onClick={() => handleOpenTab(TAB_FOUR)}>{openTab === TAB_FOUR ? "Close" : "Open"}</button>
					</div>
				</div>
				{openTab === TAB_FOUR && renderLyrics()}
			</div>
			<div className="item">
				<div className="item-header">
					<p className="song-title">5. Only God Knows</p>
					<div className="buttons">
						<p className="time">{openTab === TAB_FIVE && playing ? `${secToMin(time)} - ` : null}2:26</p>
						{openTab === TAB_FIVE && renderCommands()}
						<button className="btn" onClick={() => handleOpenTab(TAB_FIVE)}>{openTab === TAB_FIVE ? "Close" : "Open"}</button>
					</div>
				</div>
				{openTab === TAB_FIVE && renderLyrics()}
			</div>
			<div className="item">
				<div className="item-header">
					<p className="song-title">6. Only God Knows - Reprise</p>
					<div className="buttons">
						<p className="time">{openTab === TAB_SIX && playing ? `${secToMin(time)} - ` : null}1:36</p>
						{openTab === TAB_SIX && renderCommands()}
						<button className="btn" onClick={() => handleOpenTab(TAB_SIX)}>{openTab === TAB_SIX ? "Close" : "Open"}</button>
					</div>				
				</div>
				{openTab === TAB_SIX && renderLyrics()}
			</div>
        </div>
    )
}

export default Home;
